import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $d11Stops,
  $d11Switches,
  $isPreset,
} from '../../../models/rbpLiteModel/index.js';
import {
  changeLayerVisibility,
  changePointerOnLayer,
} from '../../../utils/mapbox-utils.js';
import { $isDarkTheme } from '../../../models/authModel/index.js';

const onClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();
  const html = `
            <div class="popup_content_wrapper">
              <div class="popup_title">${feature.properties.name}</div>
              <div class="popup_item_wrapper popup_item_even">
                <div class="popup_item_field">Количество маршрутов:</div> 
                <div class="popup_item_value">${
                  feature.properties.unique_count || '-'
                }</div>
              </div>
              <div class="popup_item_wrapper popup_item_odd">
                <div class="popup_item_field">Среднее время ожидания, мин:</div> 
                <div class="popup_item_value">${
                  Math.round(feature.properties.avg) || '-'
                }</div>
              </div>
            </div>`;
  new mapboxgl.Popup().setLngLat(coordinates).setHTML(html).addTo(window.map);
};

function LitePublicTransportStops() {
  const mapLoaded = useUnit($mapLoaded);
  const d11Switches = useUnit($d11Switches);
  const isPreset = useUnit($isPreset);
  const d11Stops = useUnit($d11Stops);
  const isDark = useUnit($isDarkTheme);

  const createLayer = (update) => {
    const stopsData = {
      type: 'FeatureCollection',
      features: d11Stops,
    };

    if (update) {
      window.map.getSource('lite_stops_source').setData(stopsData);
    } else {
      if (!window.map.getSource('lite_stops_source')) {
        window.map.addSource('lite_stops_source', {
          type: 'geojson',
          data: stopsData,
        });
      }

      if (!window.map.getLayer('lite_stops_layer')) {
        window.map.addLayer({
          id: 'lite_stops_bg_layer',
          type: 'circle',
          source: 'lite_stops_source',
          paint: {
            'circle-color': 'white',
            'circle-radius': [
              'case',
              ['<', ['get', 'unique_count'], 5],
              11,
              ['<', ['get', 'unique_count'], 10],
              13,
              ['<', ['get', 'unique_count'], 20],
              16,
              11,
            ],
          },
        });

        window.map.addLayer({
          id: 'lite_stops_layer',
          type: 'symbol',
          source: 'lite_stops_source',
          layout: {
            'icon-allow-overlap': true,
            'icon-size': [
              'case',
              ['<', ['get', 'unique_count'], 5],
              2,
              ['<', ['get', 'unique_count'], 10],
              2.5,
              ['<', ['get', 'unique_count'], 20],
              3,
              2,
            ],
            'icon-image': 'stops',
          },
        });
        window.map.addLayer({
          id: 'lite_stops_label_layer',
          type: 'symbol',
          source: 'lite_stops_source',
          layout: {
            'text-field': ['get', 'unique_count'],
            'text-offset': [1, -1],
          },
          paint: {
            'text-color': isDark ? '#fff' : '#000',
          },
        });
      }

      window.map.on('click', 'lite_stops_layer', onClick);
      changePointerOnLayer('lite_stops_layer', true);

      changeLayerVisibility('lite_stops_layer', false);
      changeLayerVisibility('lite_stops_label_layer', false);
      changeLayerVisibility('lite_stops_bg_layer', false);

      setTimeout(() => {
        window.map.moveLayer('lite_hexagons_layer', 'lite_stops_bg_layer');
        window.map.moveLayer('lite_hexagons_layer', 'lite_parking_bg_layer');
      }, 500);
    }
  };

  useEffect(() => {
    if (mapLoaded && d11Stops.length > 0) {
      if (window.map.getLayer('lite_stops_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, d11Stops]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('lite_stops_layer')) {
      if (isPreset) {
        if (d11Switches.public_transport) {
          changeLayerVisibility('lite_stops_layer', true);
          changeLayerVisibility('lite_stops_label_layer', true);
          changeLayerVisibility('lite_stops_bg_layer', true);
        } else {
          changeLayerVisibility('lite_stops_layer', false);
          changeLayerVisibility('lite_stops_label_layer', false);
          changeLayerVisibility('lite_stops_bg_layer', false);
        }
      } else {
        changeLayerVisibility('lite_stops_layer', false);
        changeLayerVisibility('lite_stops_label_layer', false);
        changeLayerVisibility('lite_stops_bg_layer', false);
      }
    }
  }, [mapLoaded, isPreset, d11Switches]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('lite_stops_label_layer')) {
      if (isDark) {
        window.map.setPaintProperty(
          'lite_stops_label_layer',
          'text-color',
          '#fff'
        );
      } else {
        window.map.setPaintProperty(
          'lite_stops_label_layer',
          'text-color',
          '#000'
        );
      }
    }
  }, [isDark, mapLoaded]);

  return null;
}

export default LitePublicTransportStops;
